import React, { Component } from 'react';
import { I18nextProvider, Translation } from 'react-i18next';
import setupI18next from './i18n';
import TranslationContext from '../context/TranslationContext';
import { TemplateProps } from '../types/template';

interface PageContextType {
  locale?: string;
  data?: unknown;
  [key: string]: unknown;
}

interface I18nHOCProps {
  pageContext?: PageContextType;
  data?: unknown;
  [key: string]: unknown;
}

interface I18nHOCState {
  data?: unknown;
  ns?: string;
  [key: string]: unknown;
}

const translatePage =
  <P extends object = TemplateProps>(options: Partial<I18nHOCState> = {}) =>
  (Comp: React.ComponentType<P>) => {
    class I18nHOC extends Component<I18nHOCProps, I18nHOCState> {
      i18n: ReturnType<typeof setupI18next>;
      constructor(props: I18nHOCProps) {
        super(props);
        const { pageContext = {}, data } = props;
        this.state = {
          ...options,
          data: data || pageContext.data,
        };
        this.i18n = setupI18next(pageContext);
        this.activateLng();
      }

      activateLng = () => {
        const { pageContext = {} } = this.props;
        const { locale = '' } = pageContext;
        const { data } = this.state;
        this.parseFromContext(data);
        this.i18n.changeLanguage(locale.toUpperCase() || '');
      };

      parseFromContext = (data: unknown) => {
        const { pageContext = {} } = this.props;
        const { locale = '' } = pageContext;
        if (data && typeof data === 'object' && data !== null) {
          const lng = locale.toUpperCase();
          const ns = (data as { ns?: string }).ns;
          const content = (data as { content?: unknown }).content;
          if (ns && content && !this.i18n.hasResourceBundle(lng, ns)) {
            this.i18n.addResourceBundle(lng, ns, content);
          }
        }
      };

      render() {
        const { ns } = this.state;
        const { pageContext = {} } = this.props;
        const { locale = '' } = pageContext;
        return (
          <I18nextProvider i18n={this.i18n} defaultNS={ns}>
            <Translation>
              {(t, { i18n }) => (
                <TranslationContext.Provider
                  value={{
                    t: (x: string, y?: object) =>
                      t(x, y as Record<string, unknown>),
                    i18n,
                  }}
                >
                  <Comp {...(this.props as P)} locale={locale} />
                </TranslationContext.Provider>
              )}
            </Translation>
          </I18nextProvider>
        );
      }
    }
    return I18nHOC;
  };

export default translatePage;
